// extracted by mini-css-extract-plugin
export default {"threadContentWrapper":"MdtThread_threadContentWrapper__v7POv"};